import React from 'react';
import { useSelector } from 'react-redux';

import { Section } from 'features/order-tracker/shared-components';
import { getOrderSummary } from 'features/order-tracker/store/selectors';

import { HelpBox } from './components';
import { HELP_BOX_INFO, TITLE_BLOCK } from './constants';
import { getLinks } from './helpers';

import styles from './styles.module.scss';

export const HelpSection: React.FC = () => {
  const { isCloudVoiceOrder, isBroadbandOrder } = useSelector(getOrderSummary);

  if (!isCloudVoiceOrder && !isBroadbandOrder) {
    return null;
  }

  const links = HELP_BOX_INFO.map(({ title, columnNumber }) => ({
    title,
    columnLinks: getLinks(isCloudVoiceOrder, isBroadbandOrder, columnNumber),
  }));

  return (
    <Section>
      <h2 className={styles.sectionTitle}>{TITLE_BLOCK}</h2>
      <div className={styles.sectionContent}>
        {links.map(({ title, columnLinks }) => (
          <HelpBox key={title} links={columnLinks} title={title} />
        ))}
      </div>
    </Section>
  );
};
